module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/2-b4567db036ada7e630af22da571a09bf.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/2.mp3
// module id = 66
// module chunks = 0